

































import Vue from 'vue'
import Component from 'vue-class-component'
import { Inject, Prop } from 'vue-property-decorator'
import { FormGroup } from '@/shared/forms/form-group'
import { ResourceVariant } from '@/api/generated'
import RespondecoToolbar from '@/shared/components/toolbar/respondeco-toolbar.vue'
import RespondecoToolbarItem from '@/shared/components/toolbar/respondeco-toolbar-item.vue'
import ResourceItem from '@/business/resource/components/resource-item.vue'
import draggable from 'vuedraggable'
import { resourceDialog } from '@/shared/components/resource-dialog'
import { Injector } from '@/config/dependency-injection'
import { NotificationService } from '@/shared/services/notification-service'

@Component({
  components: {
    draggable,
    ResourceItem,
    RespondecoToolbarItem,
    RespondecoToolbar,
  },
})
export default class RespondecoResourceGallery extends Vue {
  @Prop({
    type: Number,
  })
  public readonly aspectRatio?: number

  @Prop({
    type: String,
  })
  public readonly control!: string

  @Prop({
    default: 'common.add_resource',
    type: String,
  })
  public readonly chooseResourceTitle!: string

  @Inject()
  public readonly form!: FormGroup<any>

  get formControl() {
    return this.form.field(this.control)
  }

  get formControlValue(): ResourceVariant[] {
    return this.formControl.$model
  }

  set formControlValue(resources: ResourceVariant[]) {
    console.log(resources.map(resource => resource.location))

    this.formControl.$model = resources
  }

  get length() {
    return this.formControlValue?.length ?? 0
  }

  private notificationService = Injector.get(NotificationService)

  public openResourceDialog(): void {
    resourceDialog({
      allowedType: 'image',
      aspectRatio: this.aspectRatio,
      exclude: this.formControlValue,
      title: this.chooseResourceTitle,
    }).submitted(result => {
      const alreadyExists = this.formControlValue.find(item => item.id === result.id) !== undefined

      if (alreadyExists) {
        this.notificationService.showTranslatedMessage(
          'resource.gallery.item_already_added',
          'info',
          {
            duration: 5000,
          }
        )
      } else {
        this.formControlValue = [...this.formControlValue, result as ResourceVariant]
      }
    })
  }

  public remove(index: number): void {
    this.formControlValue = this.formControlValue
      .slice(0, index)
      .concat(this.formControlValue.slice(index + 1))
  }
}
